import { ApplicationView } from "@mixitone/mvc";
import React from "react";
import { MessageBanner } from "Components/MessageBanner";
import { ClubDetailsPageController } from "controllers/ClubDetailsPageController";
import { DashLayout } from "Components/DashLayout";
import { injectParams } from "lib/injectParams";
import { useLocation } from "react-router-dom";
import { ClubGroup } from "./ClubDetailsPage/ClubGroup";
import { ClubInfoPanel } from "./ClubDetailsPage/ClubInfoPanel";
import { ClubUpdatesPanel } from "./ClubDetailsPage/ClubUpdatesPanel";
import { GameHistory } from "./ClubDetailsPage/GameHistory";
import { NextSessionPanel } from "./ClubDetailsPage/NextSessionPanel";
import { SessionTimesPanel } from "./ClubDetailsPage/SessionTimesPanel";

const ControlledClubDetailsPage: React.FC = () => {
  const controller = ClubDetailsPageController.use();
  const { club } = controller.state;
  const { state } = useLocation();
  const message = state?.message;

  return (
    <DashLayout title={club.name}>
      {message && <MessageBanner message={message} type={"success"} />}
      <div className="flex flex-col gap-6 pb-6">
        <ClubInfoPanel />
        <ClubUpdatesPanel />
        <NextSessionPanel />
        <SessionTimesPanel />
        <ClubGroup />
        <GameHistory />
      </div>
    </DashLayout>
  );
};

const ClubDetailsPage = injectParams(
  ClubDetailsPageController.scope(ApplicationView(ControlledClubDetailsPage)),
);
export { ClubDetailsPage };
